import I18n from '../../../config/i18n';

import iconTeaserGlobe from '../assets/globe.svg';
import iconTeaserLuxembourg from '../assets/civil-ensign-of-luxembourg.svg';
import iconTeaserHeart from '../assets/heart-icon.svg';

const iconTeaser = () => [
  {
    icon: iconTeaserGlobe,
    text: I18n.t('home.teaser.text_1'),
  },
  {
    icon: iconTeaserLuxembourg,
    text: I18n.t('home.teaser.text_2'),
  },
  {
    icon: iconTeaserHeart,
    text: I18n.t('home.teaser.text_3'),
  },
];

export default iconTeaser;
